import React, { createContext, useContext, useState, useCallback, useRef, useMemo, useEffect } from 'react'

type TRegionLoadingContext = {
  isLoadingRegionSwitch: boolean
  startRegionLoading: () => void
}

const RegionLoadingContext = createContext<TRegionLoadingContext | undefined>(undefined)

export const RegionLoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isLoadingRegionSwitch, setIsLoadingRegionSwitch] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const startRegionLoading = useCallback(() => {
    setIsLoadingRegionSwitch(true)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setIsLoadingRegionSwitch(false)
    }, 400)
  }, [])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const value = useMemo(
    () => ({ isLoadingRegionSwitch, startRegionLoading }),
    [isLoadingRegionSwitch, startRegionLoading],
  )

  return <RegionLoadingContext.Provider value={value}>{children}</RegionLoadingContext.Provider>
}

export const useRegionLoading = () => {
  const context = useContext(RegionLoadingContext)
  if (!context) {
    throw new Error('useRegionLoading deve ser usado dentro de RegionLoadingProvider')
  }
  return context
}
